import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import { Routes } from './routes';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import { GlobalContext } from './contexts';
import InactivityLogout from './components/inactivityLogout';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GlobalContext>
    <Router>
      <InactivityLogout>
        <NotificationContainer />
        <Routes />
      </InactivityLogout>
    </Router>
  </GlobalContext>
);